import React from "react"
import SideBar from "../common/layout/sidebar.component.jsx"
import ProductTabs from "../common/layout/tabs/products.component.jsx"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing/index"

const Products = () => {
    SideBar.activateMenu("product")

    return (
        <>
            <ProductTabs />
            <GenericListing
                objectType={ObjectType.PRODUCTS}
            />
        </>
    )
}

export default Products


// WEBPACK FOOTER //
// ./src/product/Products.tsx